import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import plugins from '@/plugins'
import '@/assets/styles/index.css'
import '@/permission'

const app = createApp(App)

app.use(store)
app.use(router)
app.use(plugins)
app.mount('#app')
